export type IgetStaticJson = <T>(filename: string) => Promise<T>
const getStaticJson: IgetStaticJson = async (fileName: string) => {
  const response = await fetch(fileName)
  if (!response.ok) {
    return await Promise.reject(response)
  }
  const jsonResponse = await response.json()

  return jsonResponse
}

export { getStaticJson }
